import { Modal } from "antd";
import {
  ActionButtons,
  Caption,
  ContentRow,
  ModalContent,
  StyledImage,
  StyledLink,
} from "./FacilityAppDownload.styles";
import { VerticalSpacing } from "src/designsystem/VerticalSpacing/VerticalSpacing";
import { GETTING_STARTED, GettingStartedActionValues } from "../FacilityOnboarding";

export interface FacilityAppDownloadProps {
  visible: boolean;
  onCancel: () => void;
  logGettingStartedEvents: (action: GettingStartedActionValues, subAction?: string) => void;
}

export function FacilityAppDownload({
  visible,
  onCancel,
  logGettingStartedEvents,
}: FacilityAppDownloadProps) {
  return (
    <Modal visible={visible} width={780} maskClosable={false} onCancel={onCancel} footer={null}>
      <ModalContent>
        <Caption>Download the Clipboard Workplace Mobile App</Caption>
        <VerticalSpacing size="xl" />
        <ContentRow>
          <StyledImage
            src={`${process.env.REACT_APP_BASE_PATH || "/"}facility_app_qr.png`}
            alt="Workplace App QR"
          />
          <ActionButtons>
            <p>Scan the QR code from your phone by opening your camera app, or:</p>
            <StyledLink
              href="https://apps.apple.com/us/app/clipboard-facility/id1594128575?itsct=apps_box_link&itscg=30200"
              target="_blank"
              onClick={() =>
                logGettingStartedEvents(GETTING_STARTED.DOWNLOAD_MOBILE_APP, "click ios button")
              }
            >
              Click to download for iOS
            </StyledLink>
            <StyledLink
              href="https://play.google.com/store/apps/details?id=com.clipboardstaffing.facility&hl=en&gl=US"
              target="_blank"
              onClick={() =>
                logGettingStartedEvents(GETTING_STARTED.DOWNLOAD_MOBILE_APP, "click android button")
              }
            >
              Click to download for Android
            </StyledLink>
          </ActionButtons>
        </ContentRow>
      </ModalContent>
    </Modal>
  );
}
